module.exports = __webpack_public_path__ + "img/amtw_bank.72e4c54f.png";